import React from 'react'
import { CircularProgress, CircularProgressProps } from '@mui/material'

const Spin = React.forwardRef((props: CircularProgressProps, ref) => {
  return <CircularProgress {...props} ref={ref} />
})

Spin.displayName = 'Spin'
export default Spin
